// IconButton — icon-only button. `label` is REQUIRED and becomes aria-label.

import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> {
  label: string;
  size?: "sm" | "md" | "lg";
  tone?: "neutral" | "primary";
  active?: boolean;
  children: ReactNode;
}

export function IconButton({
  label,
  size = "md",
  tone = "neutral",
  active,
  className,
  children,
  type = "button",
  ...rest
}: IconButtonProps) {
  return (
    <button
      type={type}
      aria-label={label}
      aria-pressed={active ? true : undefined}
      className={cn("lex-icon-btn", className)}
      data-size={size}
      data-tone={tone}
      data-active={active ? "" : undefined}
      {...rest}
    >
      <span aria-hidden="true" style={{ display: "inline-flex" }}>{children}</span>
    </button>
  );
}

export default IconButton;
